import { useRouter } from 'next/router';
import { FC, PropsWithChildren, useEffect } from 'react';
import { DpFooter, DpIdleTimeOut, User } from '@greatmindsorg/assess-web-core-lib';
import { Header } from '../Components/Header/Header.component';
import { StyledContainer } from './AuthenticatedApp.styled';
import { useRipl } from '@greatmindsorg/ripl-react';
import { user as IUserRipl } from '@greatmindsorg/ripl-core';
export const AuthenticatedApp: FC<PropsWithChildren> = ({
  children
}) => {
  const userRipl = useRipl()?.getUser();
  const isStudent = !!userRipl?.roles.includes(IUserRipl.Role.Student);
  const router = useRouter();
  document.body.classList.add('gm', 'student');
  useEffect(() => {
    const handleRouteChange = url => {
      const mainContainer = document.querySelector('.main-container');
      if (mainContainer && (url.includes('assignment') || url.includes('resources'))) {
        mainContainer.scrollTo({
          top: 0
        });
      }
    };
    router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events]);
  return <StyledContainer>
      <DpIdleTimeOut user={{
      ...userRipl,
      isStudent
    } as User} />
      <Header />
      <div className="main-container">
        <div className="page-body">
          <main id="main" tabIndex={-1} className="layout d-flex">
            {children}
          </main>
        </div>
        <DpFooter />
      </div>
    </StyledContainer>;
};